import { isAndroid, isIOS } from '../core/util';

const NET_MAP = {
  fail: 'none',
  wifi: 'wifi',
  edge: '2g',
  wwan: '3g',
  '4g': '4g',
};

function checkJSBridgeReady(JSBNS, callback) {
  if (JSBNS) {
    callback(JSBNS);
  } else if (
    typeof window.WeixinJSBridge === 'object'
    && typeof window.WeixinJSBridge.invoke === 'function'
  ) {
    callback(window.WeixinJSBridge);
  } else {
    document.addEventListener(
      'WeixinJSBridgeReady',
      () => callback(window.WeixinJSBridge),
      false,
    );
  }
}
export default function (JSBNS, callback) {
  checkJSBridgeReady(JSBNS, (JSBNS) => {
    const params = {
      network_type() {
        return new Promise((resolve) => {
          JSBNS.invoke('getNetworkType', {}, (res) => {
            let type = (res.err_msg || res.errMsg || '').replace(
              /^network_type:/,
              '',
            );
            if (type === 'wwan' && res.subtype === '4g') {
              type = '4g';
            }
            resolve(NET_MAP[type]);
          });
        });
      },
    };
    if (isAndroid) {
      Object.assign(params, {
        imei: '',
        imsi: '',
        android_id: '',
      });
    } else if (isIOS) {
      Object.assign(params, {
        idfa: '',
        idfv: '',
      });
    }
    callback(params);
  });
}
